const isEmpty = val => val === undefined || val == null || val.length <= 0 || Object.values(val).length <= 0;
const isStringAndNotNull = str => typeof str === 'string' && !(str === '');

const isValidUUID = (uuid) => {
  const uuidRegex = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return typeof uuid === 'string' && uuidRegex.test(uuid);
};

const filterValidUUIDs = (ids) => {
  if (!Array.isArray(ids)) return [];
  return ids.filter(isValidUUID);
};

const utilsCommonFunctions = { isEmpty, isStringAndNotNull, isValidUUID, filterValidUUIDs };
export default utilsCommonFunctions;